import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import { COMMUNITY_PUBLICATION_FREQUENCY } from 'modules/community/constants'
import type { TCommunity } from 'modules/community/types'

export type TCommunityFrequencyRenderProps = {
  frequencyType: string
  frequencyValue: string
}

export type TCommunityFrequencyProps = {
  community: TCommunity
  render: TFCC<TCommunityFrequencyRenderProps>
}

export const useCommunityFrequency = ({ community }: Omit<TCommunityFrequencyProps, 'render'>) => {
  const { t } = useTranslation()

  const frequencyValue =
    community.publicationFrequencyType === 'weekly'
      ? dayjs.weekdays()[community.publicationFrequencyValue]
      : community.publicationFrequencyValue
  const frequencyType = community.publicationFrequencyType

  return {
    frequencyType,
    frequencyValue,
    frequencyText: {
      [COMMUNITY_PUBLICATION_FREQUENCY.DAILY]: t('community:publication.frequency.type.daily'),
      [COMMUNITY_PUBLICATION_FREQUENCY.WEEKLY]: t('community:publication.frequency.type.weekly', {
        value: frequencyValue,
      }),
      [COMMUNITY_PUBLICATION_FREQUENCY.MONTHLY]: t('community:publication.frequency.type.monthly', {
        value: frequencyValue,
      }),
      [COMMUNITY_PUBLICATION_FREQUENCY.SPORADICALLY]: t('community:publication.frequency.type.sporadically'),
      [COMMUNITY_PUBLICATION_FREQUENCY.UNKNOWN]: '',
    }[frequencyType],
  }
}
